import CreateForm from "../Comp/CreateComponent/FromV2";
// import { axiosPrivate } from "../api/axios/axios";
import { useEffect, useState } from "react";
import CustomInput from "../Comp/Form/CustomInput";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import { Paper } from "@mui/material";
import { useLocation } from "react-router-dom";
import "../Comp/CreateComponent/CreateForm.css";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const Create = () => {
  const axiosPrivate = useAxiosPrivate();
  const GET_DEALS_URL = "/api/deals/getdealsapp";
  const [link, setLink] = useState();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const rowData = location?.state?.fullRowData;

  const tbd_deal_type =
    location.state?.tbd_deal_type ||
    (location.pathname === "/createdeal"
      ? 2
      : location.pathname === "/createmessage"
      ? 3
      : "");
  const isDeal = (tbd_deal_type === 2 || tbd_deal_type === 1);
  const isMessage = tbd_deal_type === 3;

  console.log("Create Type", tbd_deal_type)

  const handleChange = (event) => {
    setLink(event.target.value);
  };
  // console.log(link, "link");
  const [dealsData, setDealsData] = useState({});
  const [messageData, setMessageData] = useState({

  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (link) {
        setLoading(true);
        const response = await axiosPrivate.post(GET_DEALS_URL, {
          url: link,
        });
        // console.log(response, "response");
        setDealsData({ tbd_deal_type, ...response?.data?.data, sub_category: response?.data?.data?.sub_category || response?.data?.data?.sub_cat_id });
        // setGraphData(response.data.graph_data)
        // console.log(response, "response");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rowData && isDeal) {
      setDealsData({ tbd_deal_type,...rowData});
    }
    if (rowData  && isMessage) {
      setMessageData({ tbd_deal_type, ...rowData });
    }

  }, []);



  const handleSearchButtonClick = (e) => {
    handleSubmit(e);
  };
  // console.log(dealsData, "deals data");
  return (
    <div>
      {!rowData && isDeal && (
        <div className="">
          <form onSubmit={handleSubmit} className="formLink">
            <Paper
              elevation={0}
              sx={{ width: "100%", padding: "16px", marginBottom: "16px" }}
            >
              <CustomInput
                className="width-full"
                type="search"
                handelChange={handleChange}
                label="Past Link"
                variant={"standard"}
                value={link}
                withButton={true}
                icon={<SearchIcon />}
                handelButtonClick={handleSearchButtonClick}
                loading={loading}
              // setLink={setLink}
              />
            </Paper>
          </form>
        </div>
      )}

      {(isDeal && Object.keys(dealsData).length > 0) && (<div className="mt-4">
        <CreateForm isMessage={isMessage} isDeal={isDeal} tbd_deal_type={tbd_deal_type} dealsData={dealsData} setLink={setLink} rowData={rowData} />
      </div>)}
      {(isMessage) && (<div className="mt-4">
        <CreateForm isMessage={isMessage} isDeal={isDeal} dealsData={messageData} setLink={setLink} rowData={rowData} />
      </div>)}
    </div>
  );
};
export default Create;
